import { Modal } from 'barte-design-system';

import styles from './confirm-action-modal.module.css';
import { ConfirmActionModalProps } from './confirm-action-modal.type';

export const ConfirmActionModal = ({
  isOpen,
  title,
  description,
  confirmLabel,
  cancelLabel,
  isLoading = false,
  onConfirm,
  onClose,
}: ConfirmActionModalProps) => {
  return (
    <Modal
      isOpen={isOpen}
      size="sm"
      title={title}
      onClose={isLoading ? () => {} : onClose}
      footer={{
        buttonLayout: 'hug',
        secondaryButton: {
          children: cancelLabel,
          variant: 'outline',
          onClick: onClose,
          disabled: isLoading,
        },
        primaryButton: {
          children: confirmLabel,
          onClick: onConfirm,
          disabled: isLoading,
        },
      }}
    >
      <p className={styles['confirm-description']}>
        {description}
      </p>
    </Modal>
  );
};